/* globals theme */

export function initProductTestimonials() {
  const productTestimonialsSections = document.querySelectorAll('[data-section-type="product-testimonials"]');
  productTestimonialsSections.forEach((container) => {
    const sectionId = container.getAttribute('data-section-id');
    const slideshow = container.querySelector('#Testimonials-' + sectionId);

    const options = {
      adaptiveHeight: slideshow.hasAttribute('data-adaptive-height'),
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
      cellAlign: 'left',
    };

    // Do not wrap when only a few blocks
    if (slideshow.dataset.count <= 3) {
      options.wrapAround = false;
    }
    // custom options for large screens
    if (matchMedia('screen and (min-width: 1024px)').matches) {
      options.cellAlign = 'center';
    }

    const flickity = new theme.Slideshow(slideshow, options);
  });
}
